import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-settings-sidebar',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, NgbTooltipModule, TranslocoDirective],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  @Input() isCollapseSidebar: boolean = false;
  @Input() closeSidebar!: () => void;
  @Output() toggleCollapse = new EventEmitter<void>();

  btnCollapseProps(): void {
    this.toggleCollapse.emit();
  }
}